<template>
  <div class="inline_block margintop_50">
    <Upload class="inline_block top" :on-success="handleSuccess" :action="uploadUrl">
      <Button icon="ios-cloud-upload-outline">上传数据</Button>
    </Upload>
    <DatePicker
      type="month"
      class="inline_block"
      placeholder="选择月份"
      @on-change="selectDate"
      style="width: 200px"
    ></DatePicker>
    <Button
      type="primary"
      class="inline_block"
      :disabled="isPlan"
      :loading="waiting"
      v-on:click="planData()"
    >开始规划</Button>
  </div>
</template>
<script>
import getData from "../service/getData";
import api from "../service/api";

import appConfig from "../../config/config.js";

export default {
  data: function() {
    return {
      uploadUrl: appConfig.BASE_URL + api.update,
      key: "",
      month: "",
      isPlan: true,
      waiting: false
    };
  },
  mounted() {},
  methods: {
    handleSuccess(res, file) {
      if (res.status) {
        //上传数据成功
        this.$Message.info(res.msg);
        this.key = res.key;
        this.isPlan = false;
      }
    },
    selectDate(date) {
      this.month = date;
    },
    async planData() {
      this.waiting = true;
      const res = await getData.get(api.manualPlan, {
        key: this.key,
        month: this.month
      });
      this.waiting = false;
      if (res.data && res.data.status) {
        this.$Message.info(res.data.msg);
        this.$router.push({
          path:
            "/login?ts=1521596159&sign=ab3283267806317c8720b3da2d028406&type=jly"
        });
      } else if (res.data) {
        this.$Message.info(res.data.msg);
      }
    }
  }
};
</script>

<style lang="less">
.inline_block {
  display: inline-block;
}
.margintop_50 {
  margin-top: 50px;
}
.top {
  vertical-align: top;
}
</style>


// WEBPACK FOOTER //
// src/components/Update.vue